import React, { useState, useContext } from 'react'
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentHeader } from '../../layout/Content'
import Searchbar from '../../layout/searchbar/Searchbar'
import ToolbarButton  from '../../layout/ToolbarButton'
import StockInController from '../stockin/StockInController'
import StockInListHeaderStyle from './css/StockInListHeaderStyle'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import StockInListSettingsForm from './StockInListSettingsForm'
import { appContext } from '../../../App'
import { stockInListControllerContext } from './StockInListController'

function StockInListToolbar(props) {
  const app = useContext(appContext)
  const searchInput = props.searchInput[0]
  const setContent = app.content[1]
  const stockInListController = useContext(stockInListControllerContext)
  const { reloadStockInList, selectedSIId, batchDeleteSelectedSI } = stockInListController

  const onClickSettings = (e) => {
    ReactDOM.render (
      <ModalWindow id='mw-parent' width='30' height='50' header='Settings' footer={null}>
        <StockInListSettingsForm app={app} stockInListController={stockInListController} />
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickTrash = (e) => {
    const showTrashMessageBox = () => {
      const onClick = (button) => {
        if (button === 'Yes') batchDeleteSelectedSI()
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }

      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          header="Deleting Stockin's..."
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>Will delete all selected/checked stockin records.</div>
              <br />
              <div>Do you want to continue?</div>
              <br />
            </div>
            <div className='button-container'>
              <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
              <button onClick={() => { onClick('Yes') }} className='pospro-action-btn bottom-anchor'>Yes</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    showTrashMessageBox()
  }

  return (
    <ToolbarButton>
      <button
        id='refresh-list'
        name='tb'
        disabled={searchInput}
        className={ searchInput ? 'pospro-action-btn toolbar-btn disabled-button' : 'pospro-action-btn toolbar-btn' }
        onClick={() => reloadStockInList()}
        title='Refresh List'>
        <FontAwesomeIcon icon='sync-alt'/>
        <span className='tooltip-text'>Refresh list</span>
      </button>
      <button
        id='settings'
        name='tb'
        className='pospro-action-btn toolbar-btn'
        onClick={onClickSettings}
        title='Settings'>
        <FontAwesomeIcon icon='cog'/>
        <span className='tooltip-text'>Settings</span>
      </button>
      <button
        id='stock-in'
        name='tb'
        className='pospro-action-btn toolbar-btn'
        onClick={() => setContent(<StockInController />)}
        title='Add Stocks'>
        <FontAwesomeIcon icon='plus'/>
        <span className='tooltip-text'>Add Stocks</span>
      </button>
      <button
        id='batch-delete'
        name='tb'
        className={ selectedSIId.length ? 'pospro-action-btn toolbar-btn' : 'pospro-action-btn disabled-button' }
        disabled={!selectedSIId.length}
        onClick={onClickTrash}
        title='Batch delete'>
        <FontAwesomeIcon icon='trash'/>
        <span className='tooltip-text'>Batch Delete</span>
      </button>
    </ToolbarButton>
  )
}

function StockInListHeader() {
  const app = useContext(appContext)
  const stockInListController = useContext(stockInListControllerContext)
  const { filterStockInList } = stockInListController
  const [searchStockInList, setSearchStockInList] = useState('')

  const searchbarProps = {
    search: searchStockInList,
    setSearch: setSearchStockInList,
    filter: filterStockInList 
  }

  return (
    <ContentHeader title='Stock-In Transactions List'>
      <div id='stockin-list-toolbar'>
        <Searchbar { ...searchbarProps }/>
        <StockInListToolbar searchInput={searchStockInList}/>
      </div>
      <StockInListHeaderStyle signed_in={app.client.signed_in}/>
    </ContentHeader>
  )
}

export default React.memo(StockInListHeader)